export default __webpack_public_path__ + "static/media/KZ.T.05.0594 black.2b9ef408.svg";